module.exports = __webpack_public_path__ + "static/media/iconCantine.a0100ed7.svg";